import React from 'react'
import styles from "./madeby.module.css"
import {BsLinkedin, BsGithub} from "react-icons/bs"
import {CgWebsite} from "react-icons/cg"
const MadeBy = () => {
  return (
    <div className={styles.madeby__box}>
        
        <div className={styles.myname}>Made with <span className={styles.heart}> ❤ </span> by Ankit Mishra</div>
        <div className={styles.icon__box}>
            <a  rel="noreferrer" href="https://www.linkedin.com/in/ankit-mishra07/" target="_blank"><BsLinkedin className={styles.icon_link}/></a>
            <a  rel="noreferrer" href="https://github.com/Ankit-Mishra07/" target="_blank"><BsGithub className={styles.icon_link}/></a>
            <a  rel="noreferrer" href="https://ankitmishra-portfolio.netlify.app/" target="_blank"><CgWebsite className={styles.icon_link}/></a>
        </div>
    </div>
  )
}

export default MadeBy